import { withApiActions } from './apiActionHelper';

export function fetchProxyToken() {
  return withApiActions(
    api => api.getProxyToken(),
    'PROXY_TOKEN'
  );
}
